import React, { memo, forwardRef } from "react";
const SvgRho = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11 25.296a1 1 0 01-1-1v-11.36c0-1.456.232-2.664.696-3.624.464-.96 1.104-1.68 1.92-2.16.832-.48 1.784-.72 2.856-.72 1.248 0 2.312.272 3.192.816.896.528 1.576 1.296 2.04 2.304.464 1.008.696 2.232.696 3.672 0 1.36-.248 2.536-.744 3.528-.496.976-1.184 1.728-2.064 2.256-.864.512-1.856.768-2.976.768-.64 0-1.264-.088-1.872-.264a5.25 5.25 0 01-1.608-.816h-.12c.032.256.056.672.072 1.248.016.576.024 1.224.024 1.944v2.408a1 1 0 01-1 1H11zm4.592-7.272c.768 0 1.424-.184 1.968-.552.544-.368.952-.904 1.224-1.608.288-.72.432-1.6.432-2.64 0-1.712-.328-2.976-.984-3.792-.64-.816-1.576-1.224-2.808-1.224-1.072 0-1.888.4-2.448 1.2-.56.784-.84 1.968-.84 3.552v3.888c.464.4.992.696 1.584.888a6.18 6.18 0 001.872.288z"
      />
    </svg>
  );
});
SvgRho.displayName = "SvgRho";
const MemoForwardRef = memo(SvgRho);
export default MemoForwardRef;
